// ─────────────────────────────────────────────────────────────
// Images de secours réutilisables dans tout l'espace client.
// Utilisées quand un commerce n'a pas de logo/image renseigné,
// ou quand son image ne se charge pas.
// ─────────────────────────────────────────────────────────────

/** Logo/avatar par défaut d'un commerce sans image. */
export const DEFAULT_STORE_LOGO =
  'https://readdy.ai/api/search-image?query=Minimalist%20flat%20vector%20storefront%20emblem%20with%20a%20soft%20awning%20and%20a%20round%20shop%20sign%2C%20centered%20on%20a%20warm%20cream%20background%2C%20terracotta%20and%20beige%20neutral%20tones%2C%20clean%20modern%20brand%20mark%20for%20a%20generic%20online%20shop%2C%20no%20text%2C%20harmonious%20and%20simple%20composition&width=240&height=240&seq=zifek-store-default-logo-v2&orientation=squarish';

/** Image de couverture par défaut d'un commerce sans visuel. */
export const DEFAULT_STORE_COVER =
  'https://readdy.ai/api/search-image?query=Soft%20minimal%20illustration%20of%20an%20empty%20boutique%20shelf%20with%20warm%20neutral%20beige%20and%20terracotta%20tones%2C%20clean%20modern%20flat%20vector%20style%20background%2C%20calm%20and%20harmonious%20composition%2C%20no%20text&width=800&height=400&seq=zifek-store-default-cover-v2&orientation=landscape';

/** Renvoie l'image fournie si valide, sinon le logo par défaut. */
export function storeLogoOr(url?: string | null): string {
  const value = (url || '').trim();
  return value.length > 0 ? value : DEFAULT_STORE_LOGO;
}

/** Photo de profil par défaut (utilisateur sans image renseignée). */
export const DEFAULT_AVATAR =
  'https://readdy.ai/api/search-image?query=Minimalist%20flat%20vector%20user%20avatar%20portrait%20silhouette%20of%20a%20smiling%20person%20with%20soft%20neutral%20warm%20beige%20and%20terracotta%20tones%2C%20simple%20clean%20circular%20profile%20icon%20on%20plain%20light%20cream%20background%2C%20modern%20friendly%20style%2C%20no%20text&width=120&height=120&seq=zifek-default-avatar-v1&orientation=squarish';

/** Renvoie l'avatar fourni s'il est valide, sinon la photo de profil par défaut. */
export function avatarOr(url?: string | null): string {
  const value = (url || '').trim();
  return value.length > 0 ? value : DEFAULT_AVATAR;
}